import PropTypes from "prop-types";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Tab from "../components/navigation/Tab.js";
import AdminLayout from "./AdminLayout.js";

const AdminTrainingLayout = ({ trainingId, children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const labels = [
    "Informações da Formação",
    "Inscrições",
    "Sessões",
    "Avaliação Final",
    "Estatísticas",
    "Conteúdos Pedagógicos",
    "Questionários de Satisfação",
  ];
  const urls = [
    "/",
    "/enrollments",
    "/sessions",
    "/final-quiz",
    "/statistics",
    "/learning",
    "/surveys",
  ];

  // find from index 1 because first index will always return true ("/"). besides, +1 will make it so that -1 --> 0
  const selectedTab =
    urls.slice(1).findIndex((url) => location.pathname.includes(url)) + 1;

  return (
    <AdminLayout title="Formações Online">
      {trainingId && (
        <Tab
          labels={labels}
          selected={selectedTab}
          onSelectTab={(tab) =>
            navigate(`/admin/training/${trainingId}/edit${urls[tab]}`)
          }
        />
      )}
      {children}
    </AdminLayout>
  );
};

AdminTrainingLayout.propTypes = {
  trainingId: PropTypes.string.isRequired,
};

export default AdminTrainingLayout;
